import React from "react";
import { AGENCY } from "../mock";

export default function About() {
  return (
    <section id="agence" className="relative py-24 md:py-40 px-6 md:px-10 border-t border-white/5">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid md:grid-cols-12 gap-8 md:gap-16">
          <div className="md:col-span-4">
            <span className="font-mono text-xs uppercase tracking-widest text-[#FF5B24]">
              (01) — L'agence
            </span>
            <h2 className="font-display font-medium text-4xl md:text-6xl mt-6 leading-[1.05] tracking-[-0.03em]">
              Discret,
              <br />
              <span className="font-serif-i text-white/70">ténace,</span>
              <br />
              partout.
            </h2>
          </div>

          <div className="md:col-span-8 md:pt-8">
            <p className="text-xl md:text-2xl text-white/80 leading-[1.5] max-w-[720px]">
              Depuis <span className="text-[#FF5B24] font-medium">{AGENCY.years} ans</span>, une équipe de{" "}
              <span className="text-[#FF5B24] font-medium">{AGENCY.team} collaboratrices et collaborateurs</span>{" "}
              accompagne des marques B2C et B2B que nous aimons et qui nous aiment. Nous fabriquons des marques
              qui durent, plutôt que des feux d'artifice.
            </p>

            <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6">
              {AGENCY.offices.slice(0, 8).map((city, i) => (
                <div key={city} className="border-t border-white/10 pt-4">
                  <div className="font-mono text-[10px] uppercase tracking-widest text-white/40">
                    Bureau {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="font-display text-lg md:text-xl mt-2">{city}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
